import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "contactus",
  class: "bg-verylightgray py-5",
  "data-aos": "fade-up"
}
const _hoisted_2 = { class: "container py-5" }
const _hoisted_3 = { class: "text-center mb-5" }
const _hoisted_4 = { class: "text-verydarkblue font-weight-bold mb-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-inline-block border-bottom border-9 w-30 w-md-10 border-color1 mb-3" }, null, -1)

import { AxiosError, backendApi } from '@/http';
import { ref, reactive } from 'vue';
import { $t } from '@/i18n';

type FormType = {
  senderName: string | null;
  senderEmail: string | null;
  senderPhone: string | null;
  title: string | null;
  message: string | null;
  type: string | null;
};

type AlertType = {
  show: boolean;
  type: 'error' | 'success' | 'warning' | 'info' | undefined;
  text?: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactUsForm',
  setup(__props) {

const form = ref<FormType>({} as FormType);

const alert = reactive({} as AlertType);

async function submit() {
  try {
    backendApi.post(`/support-messages`, form.value);
    alert.text = $t('SENT_SUCCESSFULLY');
    alert.type = 'success';
    form.value = {} as FormType;
  } catch (error) {
    const message =
      error instanceof AxiosError && error.response?.data.message
        ? error.response.data.message
        : $t('FAILED_SINDING_MESSAGE');
    alert.text = message;
    alert.type = 'error';
  }
}


return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref($t)('HAPPY_FOR_YOUR_CONTACT')), 1),
        _hoisted_5
      ]),
      _createVNode(_component_v_row, {
        class: "mt-3",
        dense: ""
      }, {
        default: _withCtx(() => [
          (alert.text)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_alert, {
                    type: alert.type,
                    text: alert.text,
                    variant: "outlined",
                    class: "mb-3"
                  }, null, 8, ["type", "text"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: form.value.senderName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.senderName) = $event)),
                label: _unref($t)('SENDER_NAME'),
                density: "compact",
                "prepend-inner-icon": "mdi-star-outline"
              }, null, 8, ["modelValue", "label"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: form.value.senderEmail,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.senderEmail) = $event)),
                label: _unref($t)('SENDER_EMAIL'),
                density: "compact",
                "prepend-inner-icon": "mdi-star-outline"
              }, null, 8, ["modelValue", "label"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: form.value.senderPhone,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.senderPhone) = $event)),
                label: _unref($t)('SENDER_PHONE'),
                density: "compact",
                "prepend-inner-icon": "mdi-star-outline"
              }, null, 8, ["modelValue", "label"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_select, {
                modelValue: form.value.type,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.type) = $event)),
                "item-title": "key",
                "item-value": "value",
                items: [
              { key: _unref($t)('QUESTION'), value: 'question' },
              { key: _unref($t)('ISSUE'), value: 'issue' },
              { key: _unref($t)('SUGGESTION'), value: 'suggestion' },
            ],
                label: _unref($t)('CONTACT_FORM_TYPE'),
                density: "compact",
                "prepend-inner-icon": "mdi-star-outline"
              }, null, 8, ["modelValue", "items", "label"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: form.value.title,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.title) = $event)),
                label: _unref($t)('THE_TITLE'),
                density: "compact",
                "prepend-inner-icon": "mdi-star-outline"
              }, null, 8, ["modelValue", "label"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_textarea, {
                modelValue: form.value.message,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.message) = $event)),
                label: _unref($t)('THE_MESSAGE'),
                density: "compact",
                "prepend-inner-icon": "mdi-star-outline"
              }, null, 8, ["modelValue", "label"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                text: _unref($t)('SEND'),
                variant: "outlined",
                color: "primary",
                onClick: submit
              }, null, 8, ["text"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})